import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
   providedIn: 'root'
})
export class PatientDataService {

   constructor(private httpClient: HttpClient, private configService: ConfigService) {
   }

   public getPatient(id: string) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Patient/GetPatient?id=${id}`;
      return this.httpClient.get(url);
   }

   public searchPatients(firstName: string, lastName: string, dob: Date) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Patient/SearchPatients?firstName=${firstName}&lastName=${lastName}&dob=${dob}`;
      return this.httpClient.get(url);
   }

   public save(patient) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Patient`;
      return this.httpClient.post(url, patient);
   }

   public getEmptyModel() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Patient/GetEmptyModel`;
      return this.httpClient.get(url);
   }

}
